import React, { useContext } from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import Resume from "../../resume/shakil  Ahmed Front End Developer.pdf";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";

export default function Greeting() {
  const { isDark } = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                {greeting.title}{" "}
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>
              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {greeting.subTitle}
              </p>
              
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="Contact me" href="#contact" />

                <Button
                  text="Download Resume"
                  href="https://drive.google.com/u/0/uc?id=1sfU4B2_sVDFuZMhOBBK2iqAGBC1ty9qx&export=download"
                  download
                ></Button>
              </div>
            </div>
          </div>
          <div style={{ paddingLeft: "150px" }} className="greeting-image-div">
            <img
              alt="Shakilsitting on table"
              // height="10px"
              width="450px"
              src={require("../../img/headerBd.png")}
            ></img>
          </div>
        </div>
      </div>
    </Fade>
  );
}
